import { Asset, Loader, Title } from "@sicredi/react";
import React from "react";

export default function AuthenticatingPage() {
  return (
    <div
      style={{
        margin: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Title as="h1">Autenticando...</Title>
      <Loader show={true} fullScreen />
      <Asset name="sicredi-logo" />
    </div>
  );
}
